import { useNavigationHelper } from 'FrontRoyalAngular';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';
import { BasicMobileBox } from '../../BasicMobileBox';
import { BasicDesktopBox } from '../../BasicDesktopBox';

function FindCompanyStudentsBoxComponent({ companyName, mobile }: { companyName: string; mobile?: boolean }) {
    const { loadRoute } = useNavigationHelper();
    const { t } = useTranslation('back_royal', { keyPrefix: 'findCompanyStudentsBox' });

    const buttons = useMemo(
        () => [
            {
                id: 'button_view_students_and_alumni',
                text: t('button_view_students_and_alumni'),
                onPress: () => loadRoute('/student-network/people'),
            },
        ],
        [loadRoute, t],
    );

    return mobile ? (
        <FindCompanyStudentsBoxMobilePresentation
            companyName={companyName}
            onPress={buttons[0].onPress}
            buttonId={buttons[0].id}
        />
    ) : (
        <FindCompanyStudentsBoxPresentation companyName={companyName} buttons={buttons} />
    );
}

function FindCompanyStudentsBoxMobilePresentation({
    companyName,
    onPress,
    buttonId,
}: {
    companyName: string;
    onPress: () => void;
    buttonId: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'findCompanyStudentsBox' });
    return (
        <BasicMobileBox
            boxKey={SidebarBoxKey.find_company_students}
            heading={t('heading', { companyName })}
            onPress={onPress}
            buttonId={buttonId}
            ctaText={t('button_view_students_and_alumni')!}
        />
    );
}

function FindCompanyStudentsBoxPresentation({
    companyName,
    buttons,
}: {
    companyName: string;
    buttons: ButtonConfig[];
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'findCompanyStudentsBox' });
    return (
        <BasicDesktopBox
            headerText={t('heading', { companyName })}
            buttons={buttons}
            boxKey={SidebarBoxKey.find_company_students}
        >
            {t('content')}
        </BasicDesktopBox>
    );
}

export const FindCompanyStudentsBox = memo(FindCompanyStudentsBoxComponent);
